import {translate} from '@/services/translations'

const $gettext = translate.gettext.bind(translate)

/**
 * General
 */

const OTHER = 'OTHER'

/**
 * Request Statuses
 */
const STARTED = 'STARTED'
const SUBMITTED = 'SUBMITTED'
const DECLINED = 'DECLINED'
const DECLINED_NOTIFY = 'DECLINED_NOTIFY'
const APPROVED = 'APPROVED'
const PARTIALLY_APPROVED = 'PARTIALLY_APPROVED'
const PARTIALLY_APPROVED_PENDING = 'PARTIALLY_APPROVED_PENDING'
const SUBMITTED_NEW = 'SUBMITTED_NEW'
const SUBMITTED_AWAITING_USER_REPLY = 'SUBMITTED_AWAITING_USER_REPLY'
const SUBMITTED_AWAITING_ADMIN_REPLY = 'SUBMITTED_AWAITING_ADMIN_REPLY'

/**
 * Organizations
 */
const UPWARD_FUND = "TCR Upward Fund"
const NORTHWESTERN = "Northwestern"

const REQUEST_STATUS_LIST = [
  STARTED,
  SUBMITTED,
  DECLINED,
  DECLINED_NOTIFY,
  APPROVED,
  PARTIALLY_APPROVED,
  PARTIALLY_APPROVED_PENDING,
]

/**
 * Request Program month
 */
const PROGRAM_MONTH_LIST = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24]

const PAYPAL = 'PAYPAL'
const WISE = 'WISE'
const PAYOUT_TYPE_LIST = [PAYPAL, OTHER, WISE]
const PAYOUT_TYPE_CHOICES = [{value: PAYPAL, label: 'PayPal'}]

const OPEN_REQUEST_STATUSES = [STARTED, SUBMITTED, PARTIALLY_APPROVED_PENDING]
const CLOSED_REQUEST_STATUSES = [DECLINED, APPROVED, PARTIALLY_APPROVED]

// Use this for dropdown menus
const REQUEST_STATUS_CHOICES = [
  {
    value: STARTED,
    label: $gettext('Started'),
  },
  {
    value: SUBMITTED,
    label: $gettext('Submitted'),
  },
  {
    value: DECLINED,
    label: $gettext('Declined'),
  },
  {
    value: APPROVED,
    label: $gettext('Approved'),
  },
]

const REQUEST_SUBMITTED_STATUSES = [
  {
    value: SUBMITTED_NEW,
    label: $gettext('Newly Submitted'),
  },
  {
    value: SUBMITTED_AWAITING_ADMIN_REPLY,
    label: $gettext('Awaiting Admin Reply'),
  },
  {
    value: SUBMITTED_AWAITING_USER_REPLY,
    label: $gettext('Awaiting User Reply'),
  },
]

const STIPEND_REQUEST_ORGANIZATION_CHOICES = [
  {
    value: UPWARD_FUND,
    label: $gettext('Upward Fund')
  },
  {
    value: NORTHWESTERN,
    label: $gettext('Northwestern')
  },
]

/*
 * Request Declined Reasons
 */

const INCOME_TOO_LOW = 'INCOME_TOO_LOW'
const INCOME_TOO_HIGH = 'INCOME_TOO_HIGH'
const NOT_PERMANENTLY_HOUSED = 'NOT_PERMANENTLY_HOUSED'
const LIVING_WITH_FAMILY_FRIENDS_NOT_ON_LEASE = 'LIVING_WITH_FAMILY_FRIENDS_NOT_ON_LEASE'
const NO_PROOF_OF_HOUSING = 'NO_PROOF_OF_HOUSING'
const NOT_IN_SOCAL = 'NOT_IN_SOCAL'
const NOT_A_GOALS_FIT = 'NOT_A_GOALS_FIT'
const TOO_EARLY_IN_UNDERGRAD = 'TOO_EARLY_IN_UNDERGRAD'
const NO_RESPONSE_FROM_NOMINATOR_OR_NOMINEE = 'NO_RESPONSE_FROM_NOMINATOR_OR_NOMINEE'
const NOT_ELIGIBLE = 'NOT_ELIGIBLE'

const REASON_DECLINED_LIST = [
  OTHER,
  INCOME_TOO_LOW,
  INCOME_TOO_HIGH,
  NOT_PERMANENTLY_HOUSED,
  LIVING_WITH_FAMILY_FRIENDS_NOT_ON_LEASE,
  NO_PROOF_OF_HOUSING,
  NOT_IN_SOCAL,
  NOT_A_GOALS_FIT,
  TOO_EARLY_IN_UNDERGRAD,
  NO_RESPONSE_FROM_NOMINATOR_OR_NOMINEE,
  NOT_ELIGIBLE,
]

// Use this for dropdown menus
const REASON_DECLINED_CHOICES = [
  {
    value: INCOME_TOO_LOW,
    label: 'Income too low',
  },
  {
    value: INCOME_TOO_HIGH,
    label: 'Income too high',
  },
  {
    value: NOT_PERMANENTLY_HOUSED,
    label: 'Not permanently housed',
  },
  {
    value: LIVING_WITH_FAMILY_FRIENDS_NOT_ON_LEASE,
    label: 'Living with family/friends not on a lease',
  },
  {
    value: NO_PROOF_OF_HOUSING,
    label: 'No proof of housing',
  },
  {
    value: NOT_IN_SOCAL,
    label: 'Not in SoCal',
  },
  {
    value: NOT_A_GOALS_FIT,
    label: 'Not a goals fit',
  },
  {
    value: TOO_EARLY_IN_UNDERGRAD,
    label: 'Too early in undergrad',
  },
  {
    value: NO_RESPONSE_FROM_NOMINATOR_OR_NOMINEE,
    label: 'No response from nominator or nominee',
  },

  {
    value: NOT_ELIGIBLE,
    label: 'Not eligible',
  },
  {
    value: OTHER,
    label: $gettext('Other'),
  },
]

/**
 * Documentation Types
 */
const EVENT = 'EVENT'
const EXPENSE = 'EXPENSE'

/**
 * Activity Tracking Types
 */

const DOCUMENT_ADDED = "DOCUMENT_ADDED"
const DOCUMENT_DELETED = "DOCUMENT_DELETED"
const IMPACT_STATEMENT_UPDATED = "IMPACT_STATEMENT_UPDATED"
const PERSONAL_DETAILS_UPDATED = "PERSONAL_DETAILS_UPDATED"
const GOAL_PROGRESSION_UPDATED = "GOAL_PROGRESSION_UPDATED"
const PROGRAM_EXIT_UPDATED = "PROGRAM_EXIT_UPDATED"

const REQUEST_UPDATE_TYPES = [
  DOCUMENT_ADDED,
  DOCUMENT_DELETED,
  IMPACT_STATEMENT_UPDATED,
  PERSONAL_DETAILS_UPDATED,
  GOAL_PROGRESSION_UPDATED,
  PROGRAM_EXIT_UPDATED,
]

export default {
  STARTED,
  SUBMITTED,
  DECLINED,
  APPROVED,
  PARTIALLY_APPROVED,
  PARTIALLY_APPROVED_PENDING,
  REQUEST_STATUS_LIST,
  REQUEST_STATUS_CHOICES,
  OPEN_REQUEST_STATUSES,
  CLOSED_REQUEST_STATUSES,
  NOT_ELIGIBLE,
  OTHER,
  REASON_DECLINED_LIST,
  REASON_DECLINED_CHOICES,
  EVENT,
  EXPENSE,
  SUBMITTED_NEW,
  SUBMITTED_AWAITING_USER_REPLY,
  SUBMITTED_AWAITING_ADMIN_REPLY,
  REQUEST_SUBMITTED_STATUSES,
  PAYOUT_TYPE_LIST,
  PAYOUT_TYPE_CHOICES,
  PAYPAL,
  PROGRAM_MONTH_LIST,
  DOCUMENT_ADDED,
  DOCUMENT_DELETED,
  IMPACT_STATEMENT_UPDATED,
  PERSONAL_DETAILS_UPDATED,
  GOAL_PROGRESSION_UPDATED,
  PROGRAM_EXIT_UPDATED,
  REQUEST_UPDATE_TYPES,
  STIPEND_REQUEST_ORGANIZATION_CHOICES
}
